<template>
  <div class="input-group input-group-lg" :class="classes">
    <slot />
  </div>
</template>

<script>
import { mapGetters } from '../store';

export default {
  name: 'StepInputGroup',

  props: {
    columnClasses: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    ...mapGetters(['currentStep', 'stepsSet']),

    /** @returns {string} */
    classes() {
      return this.currentStep === this.stepsSet.review
        ? 'col-4 col-md-3'
        : this.columnClasses;
    },
  },
};
</script>
